<template>
  <base-layout>
    <border-box slot="sidebar">
      <projects-button-container/>
    </border-box>
    <border-box slot="content">
      <transition
        name="fade"
        @after-enter="$emit('transitionEnd')"
        @after-leave="$emit('transitionEnd')"
      >
        <div v-if="visible">
          <widget-container
            v-for="(widget, i) in widgets"
            :key="i"
            :widget="widget"
          />
        </div>
      </transition>
    </border-box>
  </base-layout>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'
import BorderBox from '@/components/BorderBox'
import WidgetContainer from '@/containers/Details/WidgetContainer'
import ProjectsButtonContainer from '@/containers/Details/ProjectsButtonContainer'

export default {
  components: {
    BaseLayout,
    BorderBox,
    WidgetContainer,
    ProjectsButtonContainer
  },
  props: {
    widgets: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Details/ContentSection.vue